import { InjectionToken } from '@angular/core';
import zipObject from 'lodash/zipObject';

export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>(
  'environmentConfig',
);

export interface EnvironmentConfig {
  production: boolean;
  oidc: {
    clientId: string;
    redirectUri: string;
    metadataUri: string;
    authorizeUri: string;
    secureUris: string[];
    noRefreshUris: string[];
    publicUris: string[];
  };
  api: {
    gateways: {
      cdn: string;
      secureApi: string;
      publicApi: string;
      gsgPublicApi: string;
      gsgSecureApi: string;
    };
    proxy: {
      headers: {
        [header: string]: string;
      };
    };
    searchIndex: string;
    salesDemo: boolean;
  };
  sessionTimeoutPopup: {
    timeoutDuration: number;
    logoutDuration: number;
    keepAliveUrl: string;
  };
  trustId: string;
  features: FeatureToggles;
}

export const environmentDefaults = {
  production: true,
  sessionTimeoutPopup: {
    timeoutDuration: 25,
    logoutDuration: 5,
    keepAliveUrl: '/app/assets/images/isam-keepalive.gif',
  },
  trustId: '504516',
};

export const oidcDefault = {
  clientId: 'chcp_spa_client',
  redirectUri: '/app/auth_callback.html',
  metadataUri: '/mga/sps/oauth/oauth20/metadata/chcp_spa_def',
  authorizeUri: '/mga/sps/oauth/oauth20/authorize',
  publicUris: [],
  noRefreshUris: [],
};

export const oidcEvernorthDefault = {
  clientId: 'evernorth_provider_spa_client',
  redirectUri: '/app/auth_callback.html',
  metadataUri: '/mga/sps/oauth/oauth20/metadata/evernorth_provider_spa_def',
  authorizeUri: '/mga/sps/oauth/oauth20/authorize',
  publicUris: [],
  noRefreshUris: [],
};

export const CDN_BASE_URL = new InjectionToken<string>('CDN_BASE_URL');

export const featureFlags = [
  'nextRelease', // dont remove me :)
  'trust',
  'patientOldView',
  'patientEnhBehaviorEmbedded',
  'patientEnhBehaviorStandalone',
  'patientEnhPower',
  'patientEnhDentalAmInNet',
  'patientEnhDentalFacets',
  'messageCenter',
  'claimsMcNotification',
  'messageCenterPreference',
  'messageCenterPrefWAM',
  'precertAppeal',
  'precertManual',
  'precertDg',
  'precertAppealDental',
  'pdlViewer',
  'newFeaturesBanner',
  'emailVerifyPopup',
  'allowMfaSetting', // this functionality is turned off and if not added back by June 2021, will be removed permanently
  'mfaVerify',
  'mfaLogin',
  'reconAppealsEnhanced',
  'claimSupportInfo',
  'claimsRecon',
  'claimsReconDental',
  'reconBanner',
  'overPaidClaimsInfo',
  'multiMatchFlaggedClaim',
  'manageAccessBulkApi',
  'claim360',
  'claim360SearchClaim',
  'claim360SearchOffice',
  'claim360SearchProvider',
  'claim360Download',
  'claim360Help',
  'csnBenefits',
  'csnCPT',
  'gtmSocCoverageDetails',
  'evpPublicPages',
  'evpSecurePages',
];

export type Feature = typeof featureFlags[number];

export type FeatureToggles = Record<Feature, boolean>;

export const featureFlagDefaults: FeatureToggles = zipObject(
  featureFlags,
  Array(featureFlags.length).fill(true),
);
